document.querySelectorAll(".supercat-six-page").forEach((root) => {
  const packageCards = Array.from(root.querySelectorAll(".package-card"));

  packageCards.forEach((card) => {
    const input = card.querySelector("input");

    if (!input) return;

    input.addEventListener("change", () => {
      packageCards.forEach((item) => item.classList.toggle("selected", item === card));
    });
  });

  const slides = Array.from(root.querySelectorAll(".gallery-slide"));
  const dots = Array.from(root.querySelectorAll(".gallery-dot"));

  dots.forEach((dot) => {
    dot.addEventListener("click", () => {
      const index = Number(dot.dataset.slide);

      slides.forEach((slide, slideIndex) => slide.classList.toggle("active", slideIndex === index));
      dots.forEach((item, dotIndex) => item.classList.toggle("active", dotIndex === index));
    });
  });
});
